require("./lib/ads");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(10937327), 3000);

var track = require("./lib/tracking");